import { useState, useEffect, useMemo } from 'react';
import { fetchCurrencyCodeList } from '@/integrations/api/currency/client';
import type { AccountWithConvertedBalance } from '@/types/account-drilldown';
import { useQuery } from '@tanstack/react-query';
import {Account} from "@/integrations/supabase/account.models.ts";

export type { AccountWithConvertedBalance };

const SESSION_STORAGE_KEY = 'currency-list';

export interface UseCurrencyConversionOptions {
  baseCurrency: string;
  accounts: Account[];
}

export interface UseCurrencyListReturn {
  currencyList: string[];
  isLoading: boolean;
  error: Error | null;
  accountColors: Map<string, string>;
}

/**
 * Custom hook for retrieving currency list
 */
export function useCurrencyList() {
  // // check session storage if we have a list of currencies first
  // try {
  //   const storedCurrencyList = sessionStorage.getItem(SESSION_STORAGE_KEY)
  //   const parsedCurrencyList = JSON.parse(storedCurrencyList);
  //   return {

  //   }
  // } catch (error) {
  //     console.warn('Failed to load currency list from session storage:', error); 
  // }

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['currencyCodeList'],
    queryFn: () => fetchCurrencyCodeList(),
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours (formerly cacheTime)
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })

  // Persist selected currency to session storage
  useEffect(() => {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.warn('Failed to save currency list to session storage:', error);
    }
  }, [data]);

  return {
    data,
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
